import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
@Injectable({
  providedIn: 'root',
})
export class consultarLogsAuditoriaService {
  url: string = environment.apiLocalUrl;

  constructor(private http: HttpClient) {}

  urlparametros: string = `${this.url}parametros/servicios`;
  urlauditoria: string = `${this.url}intermediarioFinanciero/services/auditoria`;

  getTipoDocumentos() {
    return this.http.get(`${this.urlparametros}/tipoDocIdentidad`).pipe(catchError(HandleHttpError));
  }

  //Consulta log Auditoria

  auditoriaConsultas(body:any){
    return this.http.post(`${this.urlauditoria}/consultas`, body).pipe(catchError(HandleHttpError));    
  }

  auditoriaModulos(body:any){
    return this.http.post(`${this.urlauditoria}/modulos`, body).pipe(catchError(HandleHttpError));    
  }

  auditoriaParametrizacion(body:any){
    return this.http.post(`${this.urlauditoria}/parametrizacion`, body).pipe(catchError(HandleHttpError));    
  }

  auditoriaTransacciones(body:any){
    return this.http.post(`${this.urlauditoria}/transacciones`, body).pipe(catchError(HandleHttpError));    
  }
  auditoriaTerminosyCondiciones(body:any){
    return this.http.post(`${this.urlauditoria}/aceptacionTerminos`, body).pipe(catchError(HandleHttpError));    
  }

  //Ver detalle de auditoria

  getAuditoriaConsultas(idAud){
    return this.http.get(`${this.urlauditoria}/consultas/detalle/${idAud}`).pipe(catchError(HandleHttpError));
  }

  getAuditoriaModulos(idAud){
    return this.http.get(`${this.urlauditoria}/modulos/detalle/${idAud}`).pipe(catchError(HandleHttpError));
  }

  getAuditoriaParametrizacion(idAud){
    return this.http.get(`${this.urlauditoria}/parametrizacion/detalle/${idAud}`).pipe(catchError(HandleHttpError));
  }

  getAuditoriaTransacciones(idAud){
    return this.http.get(`${this.urlauditoria}/transacciones/detalle/${idAud}`).pipe(catchError(HandleHttpError));
  }

  //Descargar archivo

  descargaArchivoAudi(body:any){
    return this.http.post(`${this.urlauditoria}/exportar`, body).pipe(catchError(HandleHttpError));    
  } 
  
}